ApplyCancelButtons = require 'components/common/apply_cancel_buttons'
{ useI18n } = require 'lib/react_utils'
NMAVizActions = require 'actions/nma_viz_actions'

AutoCalculateConfirmation = ({ onApply, onCancel, autoCalculateModalState }) ->

  i18n = useI18n 'nma:autocalculation_modal'

  confirmationMsgKey = if autoCalculateModalState.get('type') is 'effectClassification'
    'effect_classification_confirmation'
  else
    'effect_interpretation_confirmation'

  <div className="modal-body">
    <div className="modal-content">
      <div dangerouslySetInnerHTML={{__html: i18n confirmationMsgKey}} />
      <div className="modal-content__options">
        <label className="block my-10">
          <input
            type="checkbox"
            id="clear"
            className="inline-block mr-5"
            checked={autoCalculateModalState.getIn(['options', 'clear'])}
            onChange={() ->
              NMAVizActions.setAutoCalculateOptions(
                { clear: !autoCalculateModalState.getIn(['options', 'clear'])}
              )}
          />
          <span>{i18n 'clear_previous_calculation'}</span>
        </label>
      </div>
    </div>

    <ApplyCancelButtons
      applyLabel={i18n '/actions.proceed'}
      onApply={onApply}
      onCancel={onCancel}
      applying={autoCalculateModalState.get('isCalculating')}
    />
  </div>


module.exports = AutoCalculateConfirmation